<template>
    <div class="homepage__use-cases">
        <h2 class="learning__title">
            {{ $t('lp.useCases.title') }}
        </h2>
        <div class="learning__offerings">
            <div class="offering">
                <img
                    class="offering__visual"
                    src="/images/lp/distance-learning--quickly.svg"
                    :alt="$t('lp.useCases.quickSetup.title')"
                />
                <div class="offering__content">
                    <h3 class="content__title">
                        {{ $t('lp.useCases.quickSetup.title') }}
                    </h3>
                    <p class="content__description">
                        {{ $t('lp.useCases.quickSetup.description') }}
                    </p>
                </div>
            </div>
            <div class="offering">
                <img
                    class="offering__visual"
                    src="/images/lp/distance-learning--control-time.svg"
                    :alt="$t('lp.useCases.time.title')"
                />
                <div class="offering__content">
                    <h3 class="content__title">
                        {{ $t('lp.useCases.time.title') }}
                    </h3>
                    <p class="content__description">
                        {{ $t('lp.useCases.time.description') }}
                    </p>
                </div>
            </div>
            <div class="offering">
                <img
                    class="offering__visual"
                    src="/images/lp/distance-learning--exciting.svg"
                    :alt="$t('lp.useCases.exciting.title')"
                />
                <div class="offering__content">
                    <h3 class="content__title">
                        {{ $t('lp.useCases.exciting.title') }}
                    </h3>
                    <p class="content__description">
                        {{ $t('lp.useCases.exciting.description') }}
                    </p>
                </div>
            </div>
            <div class="offering">
                <img
                    class="offering__visual"
                    :src="`/images/lp/distance-learning--progress${imageLang}.svg`"
                    :alt="$t('lp.useCases.insights.title')"
                />
                <div class="offering__content">
                    <h3 class="content__title">
                        {{ $t('lp.useCases.insights.title') }}
                    </h3>
                    <p class="content__description">
                        {{ $t('lp.useCases.insights.description') }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({ currentLanguage: 'getCurrentLanguage' }),
        imageLang() {
            switch (this.currentLanguage) {
                case 'es':
                    return '--spanish';
                case 'et':
                    return '--estonian';
                default:
                    return '';
            }
        },
    },
};
</script>

<style scoped lang="scss">
.homepage__use-cases {
    display: flex;
    flex-direction: column;
    padding: 3rem 1rem 3rem;
    position: relative;

    @include mq($w-min-desktop, min) {
        padding: 4rem 1rem 5rem;
    }

    &::after {
        content: '';
        display: block;
        width: 100%;
        background-color: #a166f0;
        position: absolute;
        left: 0;
        z-index: 1;
        transform: skewY(-4deg);
        bottom: -10px;
        height: 3%;

        @include mq($w-min-tablet, min) {
            height: 7%;
            bottom: -25px;
        }

        @include mq($w-min-desktop, min) {
            height: 10%;
            transform: skewY(-2deg);
        }
    }

    .learning {
        &__title {
            font-style: normal;
            font-weight: bold;
            font-size: 1.5rem;
            line-height: 1.8125rem;
            text-align: center;
            margin: 4rem 0 1rem;

            @include mq($w-min-xl, min) {
                font-size: 2.625rem;
                line-height: 130%;
                margin-bottom: 4rem;
            }
        }

        &__offerings {
            z-index: 4;
            max-width: 1400px;
            margin: auto;

            @include mq($w-min-tablet, min) {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
            }

            @include mq($w-min-xl, min) {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
            }

            .offering {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-bottom: 2rem;
                max-width: 530px;

                @include mq($w-min-tablet, min) {
                    flex-direction: row;
                }

                @include mq($w-min-xl, min) {
                    flex-direction: row;
                }

                &__visual {
                    min-width: 120px;
                    max-width: 120px;
                    width: 120px;
                    height: auto;
                    margin-bottom: 0.5rem;

                    @include mq($w-min-tablet, min) {
                        min-width: 150px;
                        max-width: 150px;
                        width: 150px;
                    }

                    @include mq($w-min-desktop, min) {
                        margin-bottom: 0;
                    }

                    @include mq($w-min-xl, min) {
                        min-width: 185px;
                        max-width: 185px;
                        width: 185px;
                    }
                }

                &__content {
                    .content {
                        @include mq($w-min-tablet, min) {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                        }

                        @include mq($w-min-xl, min) {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                        }

                        &__title {
                            font-style: normal;
                            font-weight: bold;
                            font-size: 1.25rem;
                            line-height: 1.5rem;
                            text-align: center;
                            padding-left: 1rem;

                            @include mq($w-min-tablet, min) {
                                text-align: left;
                            }

                            @include mq($w-min-xl, min) {
                                padding-left: 2rem;
                            }
                        }

                        &__description {
                            font-style: normal;
                            font-weight: normal;
                            font-size: 1rem;
                            line-height: 150%;
                            text-align: center;
                            margin: 0.5rem 0 0;
                            padding: 0 1rem;

                            @include mq($w-min-tablet, min) {
                                max-width: 300px;
                                text-align: left;
                            }

                            @include mq($w-min-xl, min) {
                                max-width: 320px;
                                text-align: left;
                                padding-left: 2rem;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
